import React from 'react';
import {
  ScatterChart, Cell, XAxis, YAxis, Label, Scatter, ResponsiveContainer, LabelList, Tooltip,
} from 'recharts';


const CustomTooltip = ({ active, payload }) => {
  if (active) {
    return (
      <div className="custom-tooltip">
        <p className="label">{payload[0]['payload']['label']}:</p>
        {payload[0]['payload']['header'] ?
          <div>
            <h3 className="header">{payload[0]['payload']['header']}</h3>
            <br />
          </div> : null}
        {payload[0]['payload']['text'] ?
          <p className="desc">{payload[0]['payload']['text']}</p> : null
        }
        <p className="months">Months: {payload[0]['value']}</p>
        <p className="impact">Impact (%): {payload[1]['value']}</p>
      </div>
    );
  }

  return null;
};


class ProjectPrioritizationGrid extends React.Component {
  getCellColor(x, y) {
    if ( y / x >= 22 / 4) {
      return 'rgba(42,201,64,0.3)';
    } else if (y / x <= 1) {
      return 'rgba(255,95,88,0.3)';
    }
    return 'rgba(243,202,62,0.3)';
  }

  getClassColorName(x, y) {
    if ( y / x >= 22 / 4) {
      return 'green';
    } else if (y / x <= 1) {
      return 'red';
    }
    return 'yellow';
  }

  render() {
    return (
      <div className="charts-container dot-charts-container h-103 w-100 m-0 p-0">
        <div className="h-100 w-100">
          <ResponsiveContainer>
            <ScatterChart
              width={400}
              height={400}
              margin={{
                top: 20, right: 20, bottom: 20, left: 20,
              }}
            >
              <XAxis
                type="number"
                domain={[0, 'dataMax + 5']}
                // ticks={[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]}
                interval={0}
                minTickGap={1}
                allowDecimals={false}
                name="months"
                dataKey="months"
              >
                <Label value="Time (Months)" position="bottom" fill="#FFF" style={{ fontWeight: 600 }} />
              </XAxis>
              <YAxis
                type="number"
                domain={[0, 'dataMax + 30']}
                // ticks={[0, 5, 10, 15, 20, 25, 30, 35]}
                interval={0}
                minTickGap={5}
                name="impact"
                dataKey="impact"
              >
                <Label value="Impact on Y (%)" angle={-90} position="insideLeft" fill="#FFF" style={{ fontWeight: 600 }} />
              </YAxis>
              <Tooltip cursor={{ strokeDasharray: '3 3' }} content={<CustomTooltip />} />
              <Scatter name="Project" data={this.props.data} fill="#8884d8">
                {
                  this.props.data.map((entry, index) => <Cell className={this.getClassColorName(entry.months, entry.impact)} size={1000} key={`cell-${index}`} fill={this.getCellColor(entry.months, entry.impact)} />)
                }
                 <LabelList dataKey="label" position="center" fill="#FFF"  />
              </Scatter>
            </ScatterChart>
          </ResponsiveContainer>
        </div>
        <div className="chart-legend">
        </div>
      </div>
    );
  }
}

export default ProjectPrioritizationGrid;
